var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorMoveTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2 5.88235C1.2 4.44118 2.256 3.25294 3.648 2.99412L2.754 3.87059L3.6 4.70588L6 2.34706L3.6 0L2.754 0.829412L3.702 1.75882V1.79412C2.68201 1.91443 1.74225 2.39673 1.06019 3.14995C0.378139 3.90316 0.00100142 4.87515 0 5.88235C0 8.15882 1.878 10 4.2 10H6V8.82353H4.2C2.544 8.82353 1.2 7.50588 1.2 5.88235Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorMoveTo);
export default __webpack_public_path__ + "static/media/vector-move_to.58019b8226b6a65b1745700246422386.svg";
export { ForwardRef as ReactComponent };